
export default {
  name: 'ListingMattressFinderForm',
  props: {
    mattressFinder: {
      type: Array,
      default() {
        return [];
      },
    },
    currentStep: {
      type: Number,
    },
    initialStepsInfo: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentStepItem() {
      return this.mattressFinder[this.currentStep - 1];
    },
    currentInitialStepsInfo() {
      return this.initialStepsInfo[this.currentStep - 1] || {};
    },
  },
};
